@if (windowScrolled) {
  <button id="app-scroll-to-top" class="desktop" (click)="scrollToTop()">
    <i class="fas fa-chevron-up fa-2x"></i>
    <br>Top
    </button>
  }

  @if (windowScrolled) {
    <button id="app-scroll-to-top" class="mobile" (click)="scrollToTop()">
      <i class="fas fa-chevron-up fa-lg"></i>
    </button>
  }